import AuthService from "../../../Services/authService";

export default class LeadImportParameters
{
	constructor() 
	{
		this.initialize();
	}

	initialize()
	{
		let loggedInUser=AuthService.getInstance().GetLoggedInUser();
		
		this.Name="";
		this.ProjectType="";
		this.Industry="";
		this.Description="";
		this.SourceCode="";
		this.SourceName="";
		this.AssignedToUserId=loggedInUser===undefined?"":loggedInUser.userId;
		this.OfficeId=loggedInUser===undefined?"":loggedInUser.officeId;
		this.selectedFile=null;
		this.UserId=(loggedInUser===undefined) ? 0 : loggedInUser.userId
		// UI-only (never posted - the FormData in ImportLeadsWindowDescription appends explicit
		// keys): drives the Download Template link field, mirroring UploadItem.DownloadTemplateLink.
		this.DownloadTemplateLink='./templates/Lead_Import_Template.csv';
	}
}